import { useUserLanguage } from '@/customHooks'
import { useGetOwnManagerQuery } from '@/graphql/generated'
import { capitalizeFirstLetter } from '@/helpers'

const textsData = {
  en: {
    title: 'Welcome',
    description: 'Arrange here all your things',
  },
  es: {
    title: 'Bienvenido',
    description: 'Organiza aquí todas tus cosas',
  },
}

export const UserInformationTextBox = () => {
  const { data } = useGetOwnManagerQuery()

  const userLanguage = useUserLanguage()
  const texts =
    userLanguage === 'es' ? textsData.es : textsData.en

  const firstName = capitalizeFirstLetter(
    data?.ownManager.firstName ?? 'User'
  )

  const lastName = capitalizeFirstLetter(
    data?.ownManager.lastName ?? ''
  )

  return (
    <div className="text-left text-white">
      <h1 className="text-base md:text-lg font-semibold leading-tight">
        {`${texts.title} ${firstName} ${lastName}`}
      </h1>
      <p className="text-sm opacity-80">
        {texts.description}
      </p>
    </div>
  )
}